import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./listingTile.html";
import { Padding, Variant } from '@oneappexchange/appx-design-system/modules/ax/image/image.constants';
import { getBooleanAttr, getNumberAttr, getObjectOfType } from 'wds/common';
import { i18nStore, WireI18n } from '~/modules/stores/i18nStore';
import { generateMediaUrl } from '~/modules/utilities/asset_utils';
export let ListingVariants = /*#__PURE__*/function (ListingVariants) {
  ListingVariants["Stack"] = "stack";
  ListingVariants["Queue"] = "queue";
  ListingVariants["Lite"] = "lite";
  ListingVariants["QueueTransparent"] = "queue-transparent";
  return ListingVariants;
}({});
class ListingTile extends LightningElement {
  constructor(...args) {
    super(...args);
    this.analyticsContext = void 0;
    this.sponsoredLabel = 'Sponsored';
    this.image = {};
    this.listingUrl = '#';
    this._focusIndex = -1;
    this._isSponsored = false;
    this._labelChatBadge = '';
    this._variant = ListingVariants.Stack;
    this._isLoading = false;
    this.imageVariant = Variant.Default;
    this.imagePadding = Padding.Default;
    this.imageBorder = false;
    this.showListingAction = false;
    this.actions = [];
  }
  set positionIndex(value) {
    this._positionIndex = value;
  }
  get positionIndex() {
    return this._positionIndex;
  }
  set isLoading(loading) {
    this._isLoading = loading;
  }
  get isLoading() {
    return this._isLoading;
  }
  set isSponsored(value) {
    this._isSponsored = getBooleanAttr(value);
  }
  get isSponsored() {
    return this._isSponsored;
  }
  set variant(value) {
    this._variant = value;
    this.imageVariant = Variant.Default;
    this.imagePadding = Padding.Default;
    this.imageBorder = false;
    this.showListingAction = false;
    if (value === ListingVariants.Stack) {
      this.template.host.style.setProperty('--description-top-padding', ' 1rem');
    } else if (value === ListingVariants.Queue) {
      this.template.host.style.setProperty('--description-top-padding', ' 0.5rem');
    } else {
      this.template.host.style.setProperty('--description-top-padding', ' 0.25rem');
    }
    if (value === ListingVariants.Lite || value === ListingVariants.QueueTransparent) {
      this.imagePadding = Padding.Small;
      this.imageBorder = true;
    }
    if (value === ListingVariants.Lite) {
      this.showListingAction = true;
    }
  }
  get variant() {
    return this._variant;
  }
  set props(value) {
    const props = getObjectOfType(value);
    if (props) {
      this.oafId = props.oafId;
      this.tzId = props.tzId;
      this.appExchangeId = props.appExchangeId;
      this.external_id = props.external_id;
      this.title = props.title;
      this.publisher = props.publisher;
      this.description = props.description;
      this.listingType = props.type;
      this.averageRating = getNumberAttr(props.averageRating);
      this.reviewsAmount = getNumberAttr(props.reviewsAmount);
      this.canChat = getBooleanAttr(props.chatEnabled);
      this.sponsored = getBooleanAttr(props.sponsored);
      // @ts-expect-error * Automated Type Error Fix
      this.pricing = props.pricing;
      this.actions = props.actions?.map(action => ({
        ...action,
        customClassName: `listing-action${action.customClassName ? ` ${action.customClassName}` : ''}`
      })) || [];
      if (props.listingUrl || props.url) {
        this.listingUrl = props.listingUrl || props.url;
      }
      if (props.logos) {
        const logo = props.logos.filter(item => item.logoType === 'Logo')[0];
        if (logo) {
          this.image = {
            url: generateMediaUrl(logo.mediaId),
            altText: this.altTextMessage
          };
        }
      }
      if (props.image) {
        this.image = {
          url: generateMediaUrl(props.image),
          altText: this.altTextMessage
        };
      }
      const listingCategories = props.listingCategories || [];
      const {
        i18n
      } = i18nStore.getState();
      this.categories = [...new Set(listingCategories)].filter(Boolean).slice(0, 2).map(category => {
        return {
          ...category,
          id: `${props.key || this.oafId}-${category.name?.replace(/ /g, '').trim()}`,
          ariaLabel: i18n.shared.tagAriaLabel({
            CATEGORY_NAME: category.name
          })
        };
      });

      // @ts-expect-error * Automated Type Error Fix
      if (props.sponsoredCampaigns?.length > 0) {
        // @ts-expect-error * Automated Type Error Fix
        this.sponsoredCampaign = props.sponsoredCampaigns[0];
      }
    }
  }
  get props() {
    const o = {
      tzId: this.tzId,
      appExchangeId: this.appExchangeId,
      oafId: this.oafId,
      title: this.title,
      external_id: this.external_id,
      publisher: this.publisher,
      averageRating: this.averageRating,
      reviewsAmount: this.reviewsAmount,
      canChat: this.canChat,
      description: this.description,
      listingType: this.listingType,
      listingUrl: this.listingUrl,
      positionIndex: this._positionIndex,
      image: this.image,
      listingCategories: this.categories,
      sponsoredCampaign: this.sponsoredCampaign,
      pricing: this.pricing,
      sponsoredSearch: this.sponsored
    };
    return o;
  }
  get labelChatBadge() {
    return this._labelChatBadge || (this.staticLabels.unsetLabelChatBadge ?? '');
  }
  set labelChatBadge(newValue) {
    this._labelChatBadge = newValue;
  }
  i18nCallback(i18n) {
    this.staticLabels = i18n.listingTile;
  }
  get altTextMessage() {
    const {
      i18n
    } = i18nStore.getState();
    return i18n.listingTile.altTextMessage({
      TITLE: this.title
    });
  }
  get labelByMessage() {
    const {
      i18n
    } = i18nStore.getState();
    return i18n.listingTile.labelByMessage({
      PUBLISHER: this.publisher
    });
  }
  get screnReaderMessageForRating() {
    const {
      i18n
    } = i18nStore.getState();
    return i18n.listingTile.screenReaderRating({
      RATING: this.rating
    });
  }
  get byPublisher() {
    return this.publisher ? this.labelByMessage : '';
  }
  get imageSize() {
    const sizes = {
      [ListingVariants.Stack]: '12:12',
      [ListingVariants.Queue]: 'auto',
      [ListingVariants.Lite]: 'auto',
      [ListingVariants.QueueTransparent]: 'auto'
    };
    return sizes[this.variant];
  }
  get contentSize() {
    const sizes = {
      [ListingVariants.Stack]: '12:12',
      [ListingVariants.Queue]: 'wds-queue-tile',
      [ListingVariants.Lite]: 'wds-lite-tile',
      [ListingVariants.QueueTransparent]: 'wds-queue-transparent-tile'
    };
    return sizes[this.variant];
  }
  get flow() {
    const flows = {
      [ListingVariants.Stack]: 'unset',
      [ListingVariants.Queue]: 'unset',
      [ListingVariants.Lite]: 'unset',
      [ListingVariants.QueueTransparent]: 'unset'
    };
    return flows[this.variant];
  }
  get axis() {
    const axis = {
      [ListingVariants.Stack]: 'column',
      [ListingVariants.Queue]: 'row',
      [ListingVariants.Lite]: 'row',
      [ListingVariants.QueueTransparent]: 'row'
    };
    return axis[this.variant];
  }
  get cardType() {
    const type = {
      [ListingVariants.Stack]: 'shadow',
      [ListingVariants.Queue]: 'shadow',
      [ListingVariants.Lite]: 'transparent',
      [ListingVariants.QueueTransparent]: 'transparent'
    };
    return type[this.variant];
  }
  get showPublisher() {
    return this.anyVariant([ListingVariants.Stack, ListingVariants.QueueTransparent]);
  }
  get showStars() {
    return this.anyVariant([ListingVariants.Stack, ListingVariants.Queue, ListingVariants.QueueTransparent]);
  }
  get showCategories() {
    return this.categories && this.anyVariant([ListingVariants.Stack, ListingVariants.Queue]);
  }
  get showChatBadgeStacked() {
    return this.canChat && this.variant === ListingVariants.Stack;
  }
  get showChatBadgeQueued() {
    return this.canChat && this.anyVariant([ListingVariants.Queue]);
  }
  get showChatBadgeQueueTransparent() {
    return this.canChat && this.anyVariant([ListingVariants.QueueTransparent]);
  }
  get chatBadgeColor() {
    return getComputedStyle(document.body).getPropertyValue('--sds-g-color-palette-neutral-50');
  }
  get rating() {
    return Number.isNaN(this.averageRating) ? null : this.averageRating;
  }
  checkVisibility() {
    this.template?.querySelector('wds-analytics-instrument')?.checkVisibility();
  }
  handleAnalytics(event) {
    event.detail.listing = this.props;
  }
  handleClick(event) {
    const clickEvent = new CustomEvent('navigate', {
      detail: {
        listing: this.props,
        event: event
      },
      composed: true,
      bubbles: true,
      cancelable: true
    });
    // If navigate is catched prevents the anchor to continue
    if (!this.dispatchEvent(clickEvent)) {
      event.preventDefault();
    }
  }
  clickElement(target) {
    const anchors = this.template.querySelectorAll('.link');
    if (anchors.length > 0) {
      const anchor = anchors[0];
      if (anchor.target !== target) {
        const currentTarget = anchor.target;
        anchor.target = target;
        anchor.click();
        anchor.target = currentTarget;
      } else {
        anchor.click();
      }
    }
  }
  isNewWindow(clickEvent) {
    const isMacPlatform = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
    return isMacPlatform && clickEvent.metaKey || !isMacPlatform && clickEvent.ctrlKey;
  }
  handleKeyPress(event) {
    // @ts-expect-error * Automated Type Error Fix
    if (event.code === 'Enter' && !('href' in event.target)) {
      const target = this.isNewWindow(event) ? '_blank' : '_self';
      this.clickElement(target);
    }
  }
  anyVariant(variants) {
    return variants.includes(this.variant);
  }
  handleActionKeyPress(event) {
    event.stopImmediatePropagation();
  }
  /*LWC compiler v7.1.3*/
}
ListingTile.delegatesFocus = true;
_registerDecorators(ListingTile, {
  publicProps: {
    analyticsContext: {
      config: 0
    },
    sponsoredLabel: {
      config: 0
    },
    positionIndex: {
      config: 3
    },
    isLoading: {
      config: 3
    },
    isSponsored: {
      config: 3
    },
    variant: {
      config: 3
    },
    props: {
      config: 3
    },
    labelChatBadge: {
      config: 3
    }
  },
  publicMethods: ["checkVisibility"],
  track: {
    showListingAction: 1
  },
  wire: {
    i18nCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    }
  },
  fields: ["image", "listingUrl", "_focusIndex", "_isSponsored", "_labelChatBadge", "_variant", "_isLoading", "imageVariant", "imagePadding", "imageBorder", "actions"]
});
const __lwc_component_class_internal = _registerComponent(ListingTile, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;